import script from "./detailsTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./detailsTop.vue?vue&type=script&lang=ts&setup=true"

import "./detailsTop.vue?vue&type=style&index=0&id=004749b5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004749b5"]])

export default __exports__